export default __webpack_public_path__ + "static/media/outline-icons.ab47faea.svg";